module.exports = __webpack_public_path__ + "assets/img/italian_meringue.2086142d.png";